import { useState, useEffect } from 'react';

export const useMediaQuery = () => {
	/*
		Base Font Size 16px...
		smaller smartphones: 0-768
		tablets & larger smartphones: 768-1024
		laptops, larger tablets in landscape & small desktops: 1024-1280
		larger desktops and monitors: 1280+
	*/
	const mobileMediaQuery = window.matchMedia('(max-width: 48em)'); // --> 768px +
	const tabletMediaQuery = window.matchMedia('(min-width: 48em) and (max-width: 64em)'); // --> 768px - 1024px
	const laptopMediaQuery = window.matchMedia('(min-width: 64em) and (max-width: 80em)'); // --> 1024px - 1280px
	const desktopMediaQuery = window.matchMedia('(min-width: 80em)'); // --> 1280px

	const [canMobile, setCanMobile] = useState(false);
	const [canTablet, setCanTablet] = useState(false);
	const [canLaptop, setCanLaptop] = useState(false);
	const [canDesktop, setCanDesktop] = useState(false);
	const [isMobile, setIsMobile] = useState(false);
	const [isTablet, setIsTablet] = useState(false);
	const [isLaptop, setIsLaptop] = useState(false);
	const [isDesktop, setIsDesktop] = useState(false);

	useEffect(() => {
		if (canDesktop) {
			setIsMobile(false);
			setIsTablet(false);
			setIsLaptop(false);
			setIsDesktop(true);
		} else if (canLaptop && !canDesktop) {
			setIsMobile(false);
			setIsTablet(false);
			setIsLaptop(true);
			setIsDesktop(false);
		} else if (canTablet && !canLaptop && !canDesktop) {
			setIsMobile(false);
			setIsTablet(true);
			setIsLaptop(false);
			setIsDesktop(false);
		} else if (canMobile && !canTablet && !canLaptop && !canDesktop) {
			setIsMobile(true);
			setIsTablet(false);
			setIsLaptop(false);
			setIsDesktop(false);
		}
	}, [canMobile, canTablet, canLaptop, canDesktop]);

	useEffect(() => {
		const mobileListener = () => setCanMobile(mobileMediaQuery.matches);
		const tabletListener = () => setCanTablet(tabletMediaQuery.matches);
		const laptopListener = () => setCanLaptop(laptopMediaQuery.matches);
		const desktopListener = () => setCanDesktop(desktopMediaQuery.matches);
		window.addEventListener('resize', () => {
			mobileListener();
			tabletListener();
			laptopListener();
			desktopListener();
		});

		return (() => {
			window.removeEventListener('resize', () => {
				mobileListener();
				tabletListener();
				laptopListener();
				desktopListener();
			});
		});
	}, []);

	useEffect(() => {
		if (desktopMediaQuery.matches) {
			setIsMobile(false);
			setIsTablet(false);
			setIsLaptop(false);
			setIsDesktop(true);
		} else if (laptopMediaQuery.matches) {
			setIsMobile(false);
			setIsTablet(false);
			setIsLaptop(true);
			setIsDesktop(false);
		} else if (tabletMediaQuery.matches) {
			setIsMobile(false);
			setIsTablet(true);
			setIsLaptop(false);
			setIsDesktop(false);
		} else if (mobileMediaQuery.matches) {
			setIsMobile(true);
			setIsTablet(false);
			setIsLaptop(false);
			setIsDesktop(false);
		}
	}, [])

	return {
		canMobile,
		canTablet,
		canLaptop,
		canDesktop,
		isMobile,
		isTablet,
		isLaptop,
		isDesktop
	};
}